import { render, staticRenderFns } from "./UserAdminDPD.vue?vue&type=template&id=65b0d022"
import script from "./UserAdminDPD.vue?vue&type=script&lang=js"
export * from "./UserAdminDPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports